import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Menu, Globe2, Info, Mail } from 'lucide-react';
import { LanguageSelector } from './LanguageSelector';
import { Link } from 'react-router-dom';
import { HamburgerMenu } from './Navigation/HamburgerMenu';

interface HeaderProps {
  onMenuClick: () => void;
  onAboutClick: () => void;
  onContactClick: () => void;
}

// Add this SVG component
const Logo = () => (
  <svg width="36" height="36" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-3">
    <circle cx="100" cy="100" r="100" fill="#FFFFFF" />
    <circle cx="100" cy="100" r="70" fill="#2D2F4E" />
    <circle cx="100" cy="100" r="40" fill="#FFFFFF" />
  </svg>
);

export const Header: React.FC<HeaderProps> = ({
  onMenuClick,
  onAboutClick,
  onContactClick,
}) => {
  const { t } = useTranslation();
  
  return (
    <header className="bg-[#171b20] shadow-sm">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <HamburgerMenu />
            
            <div className="flex-shrink-0 flex items-center ml-4">
              <Logo />
              <span className="text-[#d0b286] font-medium">
                {t('header.short')}
              </span>
            </div>
          </div>

          <div className="flex items-center">
            <div className="mr-4">
              <LanguageSelector />
            </div>
            <button
              onClick={onAboutClick}
              className="p-2 hover:bg-[#141721] rounded-lg mr-4"
              aria-label={t('header.about')}
            >
              <Info className="w-5 h-5 text-[#d0b286] hover:text-[#d0b286]" />
            </button>
            <button
              onClick={onContactClick}
              className="p-2 hover:bg-[#141721] rounded-lg"
              aria-label={t('header.contact')}
            >
              <Mail className="w-5 h-5 text-[#d0b286] hover:text-[#d0b286]" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}; 